import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { WidgetStatus } from '../../models/widget';

@Component({
  selector: 'cw-widget-status',
  templateUrl: './widget-status.component.html',
  styleUrls: ['./widget-status.component.scss']
})
export class WidgetStatusComponent implements OnInit {
  @Input() status: WidgetStatus;

  constructor() {
  }

  ngOnInit() {
  }

  @HostBinding('class')
  get className() {
    return this.status;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/widget-status/widget-status.component.ts